import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  body {
    background: ${({ theme }) => theme.background};
    background-repeat: ${({ theme }) => theme.backgroundRepeat};
    background-size: ${({ theme }) => theme.backgroundSize};
    background-position: ${({ theme }) => theme.backgroundPosition};
    background-attachment: ${({ theme }) => theme.backgroundAttachment};
    color: ${({ theme }) => theme.color};
    margin: 0;
    padding: 0;
    min-height: 100vh;
    transition: all 0.5s ease;
    position: relative;
  }

  /* Dark mode - Animated stars */
  body::before,
  body::after {
    content: '';
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.5s ease;
  }

  /* Star layers for dark mode */
  ${({ theme }) => theme.themeClass === 'dark-theme-bg' && `
    body::before {
      background-image: 
        radial-gradient(2px 2px at 20px 30px, white, transparent),
        radial-gradient(2px 2px at 60px 70px, white, transparent),
        radial-gradient(1px 1px at 50px 50px, white, transparent),
        radial-gradient(1px 1px at 130px 80px, white, transparent),
        radial-gradient(2px 2px at 90px 10px, white, transparent),
        radial-gradient(1px 1px at 140px 50px, white, transparent),
        radial-gradient(1px 1px at 20px 100px, white, transparent),
        radial-gradient(2px 2px at 110px 30px, white, transparent),
        radial-gradient(1px 1px at 180px 90px, white, transparent),
        radial-gradient(1px 1px at 170px 20px, white, transparent);
      background-size: 200px 200px;
      background-repeat: repeat;
      animation: stars-move 100s linear infinite;
      opacity: 0.5;
    }

    body::after {
      background-image: 
        radial-gradient(1px 1px at 40px 60px, rgba(255, 255, 255, 0.8), transparent),
        radial-gradient(1px 1px at 100px 100px, rgba(255, 255, 255, 0.8), transparent),
        radial-gradient(1px 1px at 150px 40px, rgba(255, 255, 255, 0.8), transparent),
        radial-gradient(2px 2px at 70px 20px, rgba(255, 255, 255, 0.8), transparent),
        radial-gradient(1px 1px at 10px 80px, rgba(255, 255, 255, 0.8), transparent),
        radial-gradient(1px 1px at 120px 120px, rgba(255, 255, 255, 0.8), transparent);
      background-size: 200px 200px;
      background-repeat: repeat;
      animation: stars-move 150s linear infinite, twinkle 3s infinite;
      opacity: 0.4;
    }
  `}

  /* Cloud layers for light mode */
  ${({ theme }) => theme.themeClass === 'light-theme-bg' && `
    body::before {
      background-image: 
        radial-gradient(ellipse 200px 60px at 20% 30%, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6) 40%, transparent 70%),
        radial-gradient(ellipse 180px 55px at 60% 50%, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.5) 40%, transparent 70%),
        radial-gradient(ellipse 220px 70px at 40% 70%, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6) 40%, transparent 70%),
        radial-gradient(ellipse 160px 50px at 80% 20%, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.5) 40%, transparent 70%);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      animation: clouds-move 60s linear infinite;
      opacity: 1;
    }

    body::after {
      background-image: 
        radial-gradient(ellipse 180px 55px at 10% 60%, rgba(255, 255, 255, 0.85), rgba(255, 255, 255, 0.4) 40%, transparent 70%),
        radial-gradient(ellipse 200px 60px at 70% 80%, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.45) 40%, transparent 70%),
        radial-gradient(ellipse 190px 52px at 50% 15%, rgba(255, 255, 255, 0.85), rgba(255, 255, 255, 0.4) 40%, transparent 70%),
        radial-gradient(ellipse 170px 55px at 90% 55%, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.45) 40%, transparent 70%);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      animation: clouds-move 80s linear infinite reverse;
      opacity: 1;
    }
  `}

  @keyframes stars-move {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(-200px);
    }
  }

  @keyframes twinkle {
    0%, 100% {
      opacity: 0.3;
    }
    50% {
      opacity: 1;
    }
  }

  @keyframes clouds-move {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(100%);
    }
  }
`;

export default GlobalStyles;
